module.exports={
    btn:{
        tips_reelect_btn:"Ny bild",
        cancel_btn:"Annullera",
        tips_continue_dispose:"Uppskala bilder som stöds",
        tips_return:"Ny bild",
        tips_upgrade:"Uppgradera",
        tips_yes:"OK",
        delete:"Radera",
        download:"Ladda ner",
        upload_image:"Ladda upp bild",
        new_image:"Ny bild",
        save_all:"Rädda alla",
        cancel:"Inställande",
        save:"Spara",
        view_comparison:"Visa jämförelse",
        hide_comparison:"Dölj jämförelse",
        previous:"Tidigare",
        next:"Nästa",
        continue_download:"Spara bilder med vattenstämplar",
        present:"Applicera på denna bild",
        all_wait:"Applicera på bilder i väntan",
        all:"Tillämpa på alla bilder",
        history:"Historia",
        login:"Logga in",
    },
    tips:{
        please_upgrade:"Din nuvarande plan stöder inte uppladdning eller uppskalning av bilder i omgångar. Uppgradera den för att få fler fördelar.",
        errorlistinfo:"XXX bilder har valts. XXX bilder stöds, men XXX bilder stöds inte. Följande bilder stöds inte:",
        max:"Överskrid den maximala bildstorleksgränsen på 10 MB!",
        max_size:"Överskrid maxgränsen för bildsidans längd på 4096px!",
        continue_dispose:"Uppskala bilder som stöds",
        please_multiple:"Välj förstoring.",
        max_multiple:"* Din bild kommer att förstoras till högst 4K (den längsta sidan kommer inte att överstiga 4096px).",
        title:"namn",
        reasons:"Skäl",
        upload_type:"Stöds inte",
        used_up:"Antalet sparade HD-bilder utan vattenstämplar har använts. Uppgradera ditt konto. Eller så kan du spara HD-bilder med vattenstämplar.",
        edit_multiple:"Det finns flera bilder uppladdade. Välj bilder som du vill ändra förstoringen. Efter valet kommer dessa bilder att skalas upp igen till den nya förstoringen.",
        download_confirm:"Vissa bilder bearbetas fortfarande. Är du säker på att spara alla uppskalade bilder? När du sparar samma bild upprepade gånger kommer ditt antal sparade bilder inte att dras av igen.",
        waiting_save:"Vissa bilder bearbetas fortfarande. Spara senare.",
        
    },
    header:{
        title:"Aiseesoft Image Upscaler Online",
        hd:" HD-bild(er)",
        watermarks:"utan vattenstämplar kan laddas ner för närvarande.",
        view_details:"Visa detaljer",
        loading:"Läser in…",
    },
    content:{
        failed:"Misslyckades",
        completed:"Avslutad",
        processing:"Bearbetning",
        img_processing:"Bearbetar...",
        img_failed:"Det gick inte att bearbeta",
        uploading:"Laddar upp",
        img_uploading:"Laddar upp...",
        wait_upoading:"Väntar på att ladda upp...",
        waiting:"Väntar",
        img_waiting:"Väntar…",
        empty:"Tömma",
        magnification:"Förstoring:",
        drop:"Eller släpp din bildfil här för att uppskala och förbättra!",
        original:"Original:",
        output:"Produktion:",
        img_rendering1:"Din bild har skalats upp.",
        img_rendering2:"Vi jobbar på att rendera högkvalitativa bilden för förhandsgranskning. Vänta...",
        no_watermark:"Efter att ha sparats har bilden ingen vattenstämpel.",
    },
    banner_msg:"Välj en plan för Image Upscaler",
    monthly:"EN GÅNG I MÅNADEN",
    lifetime:"LIVSTID",
    choose_plan:"Välj din plan baserat på antalet bilder",
    return_home:"Grattis! Du har uppgraderat framgångsrikt. Gå tillbaka till hemsidan och använd den här produkten.",
    congratulations:"Grattis! Du har uppgraderat framgångsrikt. Fördelarna har varit bundna till den e-postadress du lämnade när du uppgraderade. Använd kontot som är registrerat eller länkat till e-postadressen till",
    login_benefits:"logga in för att använda förmåner",
    no_registered:". Om du inte har registrerat eller länkat ett konto med e-postadressen, vänligen",
    register_account:"använd e-postadressen för att registrera ett konto",
    other_accounts:" eller länka andra konton till denna e-postadress för att använda förmåner.",
    btn_close:"Stänga",
    free:"Fri",
    btn_get_started:"Komma igång",
    // access_to:"Tillgång till",
    upscale_images:"Exklusiva bilder",
    up_to:"Upp till",
    per_image:" per bild",
    resolution_of:"Upp till upplösning av",
    default_level:"Uppskala bilder på standardnivå",
    image_downloads:"2 HD-bildnedladdningar utan vattenstämpel",
    unlimited_image:"Obegränsad bildnedladdning med vattenstämpel",
    SHA256_encryption:"SHA256 krypteringsteknik",
    mon:"En gång i månaden",
    images:"bilder",
    high_resolution:" med högupplöst kvalitet",
    tax_incl:"Inkl skatt.",
    image:"bild",
    secure_checkout:"Säker utcheckning",
    everything:"Allt i gratis, och",
    upscaling_levels:"Alla uppskalningsnivåer kan väljas",
    unlimited_image_without:"Obegränsad bildnedladdning utan vattenstämpel",
    viewable_editing:"Synlig redigeringshistorik är giltig för",
    days:" dagar",
    high_level:"Hög nivå",
    priority_processing:" prioriterad behandling",
    left:"Livstid",
    resolution:" upplösning",


    "history_will":"Upphör att gälla efter",
    "history.days":"Dag(ar)",
    "history.hours":"timmar",
    "expired":"Utgånget",
    "access_to":"Med den kostnadsfria provperioden kan du bara",
    "pricing.upload_images":"Ladda upp bilder",
    "pricing.under":"under",
    "pricing.images":"bilder",
    "pricing.without_watermark":"utan vattenstämpel",
    "pricing.process_images":"Bearbeta bilder upp till",
    "pricing.pixels":"pixlar",
    "pricing.enjoy_limited":"Njut av begränsade exklusiva betyg",
    "pricing.download":"Ladda ner",
    "pricing.HD_images":"HD-bilder utan vattenstämpel",
    "pricing.and_you":"Och du kan lida av",
    "pricing.slow_upscaling":"långsam uppskalning",
    "pricing.lower_priority":"lägre prioritet",
    "pricing.without":"utan vattenmärke",
    "pricing.tax":"Skatt ingår i försäljningspriset och kommer att beräknas automatiskt baserat på ditt land och din region. I varukorgen kan du se det detaljerade skattebeloppet. Ditt slutliga betalningsbelopp ska vara detsamma som det visade priset.",
    "pricing.you_can":"Med prenumeration kan du",
    "pricing.up_to":"Ladda upp bilder upp till",
    "pricing.upscale_images":"Exklusiva bilder med",
    "pricing.no_watermark":"inget vattenmärke",
    "pricing.enhance":"Förbättra",
    "pricing.or_more":"bilder eller fler",
    "pricing.in_batch":"i parti",
    "pricing.enlarge_images":"Förstora bilder i",
    "pricing.and":"och",
    "pricing.times_with":"tider utan gräns",
    "pricing.enjoy":"Njut av",
    "pricing.of_history":"av historiens lagringstid",
    "pricing.experience":"Erfarenhet",
    "pricing.fast_upscaling":"snabb uppskalning",
    "pricing.higher_priority":"högre prioritet",
    "pricing.early_access":"Tidig tillgång till nya funktioner",
    "pricing.cancel_anytime":"Avbryt när som helst",
    "pricing.lifetime_license":"Med livstidslicens kan du",
    "pricing.and_there":"Och det kommer att finnas",
    "pricing.no_expiration":"inget utgångsdatum",
    "pricing.unless":"om du inte tar slut alla exklusiva skalor",

    "buynow.pop.credit":"kreditera",
    "buynow.pop.credits":"krediter",

    "isUnderequityTip_msg1":"Du har valt {%} bilder för batchbearbetning, och det finns inte tillräckligt med återstående förmåner. Du behöver fortfarande {%} krediter (för närvarande finns det {%} krediter kvar). Om du behöver bearbeta, köp förmåner för att fortsätta bearbeta bilderna.",
    "isUnderequityTip_msg2":"Du har valt {%} bilder för batchbearbetning, och det finns inte tillräckligt med återstående förmåner. Du behöver fortfarande {%} krediter (för närvarande finns det {%} bilder kvar av förmåner). Om du behöver bearbeta, köp förmåner för att fortsätta bearbeta bilderna.",
    "isUnderequityTip_msg3":"Du har valt {%} bilder för batchbearbetning, och det finns inte tillräckligt med återstående förmåner. Du behöver fortfarande {%} krediter (för närvarande finns det {%} krediter, {%} bilder av förmåner kvar), om du behöver bearbeta, köp förmåner för att fortsätta bearbeta bilderna.",
    "btn_buy_now":"Köp nu",
    "isEquityDepletionTip_msg":"Dina nuvarande förmåner har förbrukats. Köp fördelarna för batchbearbetning.",

    "pricing.h1":"Aiseesoft AI Photo Editor - Planer och Priser",
    "pricing.banner_content":"Få AI Photo Editor-krediter för att ta bort bildbakgrunder, upscala bilder och ta bort objekt från bilder online eller från skrivbordet.",
    "pricing.best_seller":"Bästsäljare",
    "pricing.monthly":"Månadsabonnemang",
    "pricing.credits":"krediter",
    "pricing.lifetime":"Livstid",
    "pricing.note":"Notera",
    "pricing.buy_now":"Köp nu",
    "pricing.note_content":"Köpta krediter är länkade till den e-postadress du angav i kundvagnen. För att använda dessa krediter, registrera dig eller logga in med samma e-postadress.",

    "header.buy_more":"Köp mer",
    "header.available_credits":"Tillgängliga krediter",
    "header.credits":"kredit(er)"
}